import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
import LabelImportantIcon from "@material-ui/icons/LabelImportant";
import LayersIcon from "@material-ui/icons/Layers";
import BulkActions from "../Bulk/BulkActions";
import { Button } from "../../components/ui/forms/Button";
import { PatronContext } from "../../contexts/PatronContext";
import { PaneContext } from "../../contexts/PaneContext";
import { UserContext } from "../../contexts/UserContext";
import ReorderIcon from "@material-ui/icons/Reorder";
import EnhancedTable from "../ui/Table/Enhanced/EnhancedTable1";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import Axios from "axios";
import {
  AppBar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import { Label } from "@material-ui/icons";

const columns = [
  {
    id: "externalID",
    disablePadding: false,
    label: "External ID",
  },
  {
    id: "firstName",
    disablePadding: false,
    label: "First Name",
  },
  {
    id: "lastName",
    disablePadding: false,
    label: "Surname",
  },
  {
    id: "dateOfBirth",
    disablePadding: false,
    label: "Date of Birth",
  },
  {
    id: "dateCreated",
    disablePadding: false,
    label: "Order Placed",
  },
];

const RecentOrder = ({}) => {};

const AddPatronButtons = () => {
  const [bulkOpen, setBulkOpen] = useState(false);
  const { newPatronMode, toggleNewPatronMode, changeTab, updatePreviewPane } =
    useContext(PaneContext);
  const { selectPatron } = useContext(PatronContext);
  const { userRole } = useContext(UserContext);
  const navigate = useNavigate();
  const [OrderModal, setOrderModal] = useState(false);
  const { apiUrl } = useContext(DatabaseContext);
  const { Site, email } = useContext(UserContext);
  const { siteCode } = Site;
  const [allRecentOrder, setAllRecentOrder] = useState();
  const [selectedID, setSelectedID] = useState(0);
  const [selectedDetails, setselectedDetails] = useState("");
  const [DeleteMessage, setDeleteMessage] = useState();

  const newStudent = () => {
    toggleNewPatronMode(true);
    changeTab(0);
    updatePreviewPane(null);
    selectPatron();
  };

  const getAllOrders = async () => {
    const res = await Axios.get(
      `${apiUrl}/api/library/recentorders/?siteCode=${Site.siteCode}`
    );

    setAllRecentOrder(res.data.data[0]);

    setOrderModal(true);
  };

  const GetIDAndMessage = (id) => {
    setDeleteMessage(true);
    setSelectedID(id);

    allRecentOrder.forEach((element) => {
      if (element.OrderID == id) {
        setselectedDetails(
          element.firstName +
            " " +
            element.lastName +
            "  " +
            "(" +
            element.externalID +
            ")"
        );
      }
    });
  };

  const DeleteOrder = async () => {
    setDeleteMessage(false);
    const res = await Axios.put(
      `${apiUrl}/api/library/deleterecentorder/?orderID=${selectedID}&UserEmail=${email}`
    );
    setSelectedID(0);
    getAllOrders();
  };

  return (
    <div>
      <Container>
        {!newPatronMode ? (
          <Button
            colour="secondary"
            onClick={newStudent}
            startIcon={<AddIcon />}
            margin="0 1rem 0 0.5rem"
          >
            Add New
          </Button>
        ) : (
          <Button
            onClick={() => {
              toggleNewPatronMode(false);
            }}
            startIcon={<ClearIcon />}
            margin="0 1rem 0 0.5rem"
          >
            Cancel
          </Button>
        )}
        {userRole === "admin" || userRole === "user" ? (
          <Button
            colour="success"
            onClick={() => {
              toggleNewPatronMode(false);
              navigate("/import", { replace: true });
            }}
            startIcon={<LabelImportantIcon />}
            margin="0 1rem 0 0"
          >
            Import
          </Button>
        ) : (
          <></>
        )}
        <Button
          colour="info"
          startIcon={<LayersIcon />}
          onClick={() => setBulkOpen(true)}
          margin="0 1rem 0 0"
        >
          Bulk Actions
        </Button>

        <Button
          colour="error"
          startIcon={<ReorderIcon />}
          onClick={() => getAllOrders()}
        >
          Recent Orders
        </Button>
      </Container>
      <BulkActions open={bulkOpen} close={() => setBulkOpen(false)} />

      <Dialog maxWidth open={OrderModal} onClose={() => setOrderModal(false)}>
        <DialogContent>
          <EnhancedTable
            rows={allRecentOrder}
            columns={columns}
            selectKey="OrderID"
            onRowClick={GetIDAndMessage}
            title={
              "Recent Orders that have not been printed (click order to delete)"
            }
            colour="error"
          />
        </DialogContent>
        <InputLabel style={{ paddingLeft: 30, color: "#E4A11B" }}>
          Click to delete the selected order
        </InputLabel>
        <DialogActions>
          <Button
            onClick={() => {
              setOrderModal(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        maxWidth
        open={DeleteMessage}
        onClose={() => setDeleteMessage(false)}
      >
        <DialogContent>
          Are you sure you want to cancel the order for{" "}
          <p style={{ color: "yellow" }}>{selectedDetails}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={DeleteOrder}>Yes</Button>
          <Button
            onClick={() => {
              setDeleteMessage(false);
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const Container = styled.div`
  display: flex;
  padding-left: 4rem;
`;

export default AddPatronButtons;
